/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'templates-vertical-nav';
const prefix = `${moduleName}.${componentName}`;

export const profilesLabel = `${prefix}.profilesLabel`;
export const applicationLabel = `${prefix}.applicationLabel`;
export const persistenceLabel = `${prefix}.persistenceLabel`;
export const healthMonitorsLabel = `${prefix}.healthMonitorsLabel`;
export const ipamDnsProfilesLabel = `${prefix}.ipamDnsProfilesLabel`;
export const customIpamDnsLabel = `${prefix}.customIpamDnsLabel`;
export const trafficCloneLabel = `${prefix}.trafficCloneLabel`;
export const icapProfileLabel = `${prefix}.icapProfileLabel`;
export const policiesLabel = `${prefix}.policiesLabel`;
export const l4PolicySetLabel = `${prefix}.l4PolicySetLabel`;
export const natPolicyLabel = `${prefix}.natPolicyLabel`;
export const networkSecurityPolicyLabel = `${prefix}.networkSecurityPolicyLabel`;
export const httpPolicySetLabel = `${prefix}.httpPolicySetLabel`;
export const applicationInsightsPolicyLabel = `${prefix}.applicationInsightsPolicyLabel`;
export const positiveSecurityPolicyLabel = `${prefix}.positiveSecurityPolicyLabel`;
export const groupsLabel = `${prefix}.groupsLabel`;
export const ipGroupsLabel = `${prefix}.ipGroupsLabel`;
export const stringGroupsLabel = `${prefix}.stringGroupsLabel`;
export const sslTlsCertificatesLabel = `${prefix}.sslTlsCertificatesLabel`;
export const sslTlsProfileLabel = `${prefix}.sslTlsProfileLabel`;
export const authProfileLabel = `${prefix}.authProfileLabel`;
export const authMappingProfileLabel = `${prefix}.authMappingProfileLabel`;
export const jwtServerProfileLabel = `${prefix}.jwtServerProfileLabel`;
export const certificateManagementLabel = `${prefix}.certificateManagementLabel`;
export const hsmGroupsLabel = `${prefix}.hsmGroupsLabel`;
export const ssoPolicyLabel = `${prefix}.ssoPolicyLabel`;
export const csrfPolicyPageLabel = `${prefix}.csrfPolicyPageLabel`;
export const scriptsLabel = `${prefix}.scriptsLabel`;
export const dataScriptsLabel = `${prefix}.dataScriptsLabel`;
export const controlScriptsLabel = `${prefix}.controlScriptsLabel`;
export const protocolParserScriptsLabel = `${prefix}.protocolParserScriptsLabel`;
export const autoScaleLabel = `${prefix}.autoScaleLabel`;
export const serverAutoScaleLabel = `${prefix}.serverAutoScaleLabel`;
export const launchConfigLabel = `${prefix}.launchConfigLabel`;
export const webhookLabel = `${prefix}.webhookLabel`;
export const poolGroupDeploymentLabel = `${prefix}.poolGroupDeploymentLabel`;
export const applicationRulesLabel = `${prefix}.applicationRulesLabel`;
export const positiveSecurityLabel = `${prefix}.positiveSecurityLabel`;
export const crsLabel = `${prefix}.crsLabel`;
export const botManagementPolicyListPageLabel = `${prefix}.botManagementPolicyListPageLabel`;
export const botMappingListPageLabel = `${prefix}.botMappingListPageLabel`;
export const errorPageLabel = `${prefix}.errorPageLabel`;
export const errorPageProfileLabel = `${prefix}.errorPageProfileLabel`;
export const errorPageBodyLabel = `${prefix}.errorPageBodyLabel`;
export const trustedHostProfileLabel = `${prefix}.trustedHostProfileLabel`;

export const ENGLISH = {
    [profilesLabel]: 'Profiles',
    [applicationLabel]: 'Application',
    [persistenceLabel]: 'Persistence',
    [healthMonitorsLabel]: 'Health Monitors',
    [ipamDnsProfilesLabel]: 'IPAM/DNS Profiles',
    [customIpamDnsLabel]: 'Custom IPAM/DNS',
    [trafficCloneLabel]: 'Traffic Clone',
    [icapProfileLabel]: 'ICAP Profile',
    [policiesLabel]: 'Policies',
    [l4PolicySetLabel]: 'L4 Policy Set',
    [natPolicyLabel]: 'NAT Policy',
    [networkSecurityPolicyLabel]: 'Network Security Policy',
    [httpPolicySetLabel]: 'HTTP Policy Set',
    [applicationInsightsPolicyLabel]: 'Application Insights Policy',
    [positiveSecurityPolicyLabel]: 'Positive Security Policy',
    [groupsLabel]: 'Groups',
    [ipGroupsLabel]: 'IP Groups',
    [stringGroupsLabel]: 'String Groups',
    [sslTlsCertificatesLabel]: 'SSL/TLS Certificates',
    [sslTlsProfileLabel]: 'SSL/TLS Profile',
    [authProfileLabel]: 'Auth Profile',
    [authMappingProfileLabel]: 'Auth Mapping Profile',
    [jwtServerProfileLabel]: 'JWT Server Profile',
    [certificateManagementLabel]: 'Certificate Management',
    [hsmGroupsLabel]: 'HSM Groups',
    [ssoPolicyLabel]: 'SSO Policy',
    [csrfPolicyPageLabel]: 'CSRF Policies',
    [scriptsLabel]: 'Scripts',
    [dataScriptsLabel]: 'DataScripts',
    [controlScriptsLabel]: 'ControlScripts',
    [protocolParserScriptsLabel]: 'ProtocolParserScripts',
    [autoScaleLabel]: 'AutoScale',
    [serverAutoScaleLabel]: 'Server AutoScale',
    [launchConfigLabel]: 'Launch Config',
    [webhookLabel]: 'Webhook',
    [poolGroupDeploymentLabel]: 'PoolGroup Deployment',
    [applicationRulesLabel]: 'Application Rules',
    [positiveSecurityLabel]: 'Positive Security',
    [crsLabel]: 'CRS',
    [botManagementPolicyListPageLabel]: 'Bot Management Policy',
    [botMappingListPageLabel]: 'Bot Mapping',
    [errorPageLabel]: 'Error Page',
    [errorPageProfileLabel]: 'Error Page Profile',
    [errorPageBodyLabel]: 'Error Page Body',
    [trustedHostProfileLabel]: 'Trusted Host Profile',
};
